import { ISelectionGeometryMessage } from "@kuika/kuika-cl-model";
import { useEffect, useState } from "react";
import { isSameSelectionShape, selectionGeometryStore } from "./selection-geometry-store";

/**
 * The selection geometry as React should see it. React 17 has no `useSyncExternalStore`, so this is the
 * classic external-store subscription (the board store does the same). The snapshot is replaced only when
 * the selection's SHAPE changes (`isSameSelectionShape`): the agent streams a message on every scroll and
 * resize tick, and the placement loop reads those rects live from the store — re-rendering the overlay
 * for each of them would redo the quick props' measuring for nothing. A consumer that needs the live
 * rect reads `selectionGeometryStore.getSnapshot()`.
 */
export function useSelectionGeometry(): ISelectionGeometryMessage | null {
  const [snapshot, setSnapshot] = useState<ISelectionGeometryMessage | null>(selectionGeometryStore.getSnapshot);

  useEffect((): (() => void) => {
    const update = (): void => {
      const next: ISelectionGeometryMessage | null = selectionGeometryStore.getSnapshot();
      setSnapshot((previous: ISelectionGeometryMessage | null): ISelectionGeometryMessage | null =>
        isSameSelectionShape(previous, next) ? previous : next
      );
    };
    const unsubscribe: () => void = selectionGeometryStore.subscribe(update);
    // Catch a message that landed between the first render and this effect.
    update();
    return unsubscribe;
  }, []);

  return snapshot;
}
